import * as firebase from 'firebase'
let database;
let config = {
  apiKey: "AIzaSyB5xgoBiLa2Kw_4wpGDhgtpyEqrtWGEvUE",
  authDomain: "pandemic-comment.firebaseapp.com",
  databaseURL: "https://pandemic-comment.firebaseio.com",
  projectId: "pandemic-comment",
  storageBucket: "pandemic-comment.appspot.com",
  messagingSenderId: "944946083819",
  appID: "1:944946083819:web:22ae282c448800438fcbae",
};

export const fire = () => {
  firebase.initializeApp(config);
 	database = firebase.firestore()
}

export const getFireDB = () => {
  // return database.ref('/comment').once('value')
  return database.collection("comment").get();
}

export const numOfOnce = 10;
let start = null;
export const getSomeComments = () => {
  let ref = database.collection("comment").orderBy('createdAt', 'desc');
  if(start) {
    ref = ref.startAfter(start);
  }
  return ref
    .limit(numOfOnce)
    .get()
    .then((snapshots) => {
      start = snapshots.docs[snapshots.docs.length - 1]
      return snapshots;
    })  
}

export const writeComment = (authorName, comment) => {
  return database.collection('comment').add({
    authorName: authorName,
    comment: comment,
    createdAt: new Date().getTime()
  }).then((docRef) => {
    console.log("Document written with ID: ", docRef.id);
  }).catch((err) => {
    console.error(err);
  })
}

